// eslint-disable-next-line import/prefer-default-export
export const TOGGLE_COMPONENT_KEYS = {
  CHECKOUT_DRAWER: 'CheckoutDrawer',
  PAYMENT_DRAWER: 'PaymentDrawer',
  ORDER_FLOW_DIALOG: 'OrderFlowDialog',
  PRODUCT_DIALOG: 'ProductDialog',
};
